export const KEYCODE = {
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  UP: 38,
  DOWN: 40,
};
